
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {sendcommandnewsub} from '../../api/device'
export default {
name: 'secondView',
components: {
VChart,
VTooltip,
VLine,
VScale
},
directives: {
TransferDom
},
data () {
return {
value: 'on',
showAdd: false,
addText: '添加成功',
addWarn: false,
warnText: '',
windowHeight: '',
subDevice: {},
imgArr: [
{dtype: 2, imgUrl: '../../../static/newDeviceIcon/big_second_humiture_smoke.png'}, // 烟感
{dtype: 11, imgUrl: 'static/newDeviceIcon/big_second_humiture_smoke.png'}, // 温湿度烟感
{dtype: 12, imgUrl: 'static/newDeviceIcon/big_second_water.png'}, // 水压
{dtype: 13, imgUrl: 'static/newDeviceIcon/big_second_level.png'}, // 水位
{dtype: 14, imgUrl: '../../../static/newDeviceIcon/second_door.png'}, // 门磁
{dtype: 51, imgUrl: 'static/newDeviceIcon/big_second_socket.png'}, // 智能开关
{dtype: 52, imgUrl: 'static/newDeviceIcon/big_second_humiture.png'}, // 温湿度
{dtype: '', imgUrl: '../../../static/newDeviceIcon/second_default.png'} // 15
],
isTwo: false,
chartData: [
{ date: '2021-06-05', value: 116 },
{ date: '2021-06-06', value: 129 },
{ date: '2021-06-07', value: 135 },
{ date: '2021-06-08', value: 86 },
{ date: '2021-06-09', value: 73 },
{ date: '2021-06-10', value: 85 },
{ date: '2021-06-11', value: 73 },
{ date: '2021-06-12', value: 68 },
{ date: '2021-06-13', value: 92 },
{ date: '2021-06-14', value: 130 },
{ date: '2021-06-23', value: 85 }
],
timeVal: '2021-04-23',
showPopup: false,
minDate: new Date(2020, 0, 1),
maxDate: new Date(2025, 10, 1),
currentDate: new Date(2021, 0, 17)
}
},
created () {
document.getElementsByTagName('title')[0].innerText = '子机详情'

this.subDevice = this.$store.getters.get_sub_device
console.log(this.subDevice)
this.getIsTwo()
this.windowHeight = document.documentElement.clientHeight + 'px'

},
beforeDestroy () {
document.getElementsByTagName('title')[0].innerText = '智慧安防'
},
beforeRouteEnter (to, from, next) {
next(vm => {
console.log('from', from)
})
},
mounted () {
document.getElementsByTagName('title')[0].innerText = '子机详情'
},
methods: {

getModelName (model) {
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
return 'FSK'
} else if (arr[arr.length - 1] === 'A') {
return 'ASK'
}
}
} else {
return model
}
},
getModelNameShow (model) {
if (!model) { // 504
return false
}
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
return true
} else if (arr[arr.length - 1] === 'A') {
return true
}
}
} else {
return true
}
},
getModelNameClass (model, status) {
if (status === 0) {
return 'model-left-level'
} else {
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
return 'model-left-f'
} else if (arr[arr.length - 1] === 'A') {
return 'model-left-a'
}
}
} else {
return 'model-left-z'
}
}
},
sendZigbee (item, val) {
if (item.status === 0) {
this.addWarn = true
this.warnText = '离线状态'
return
}
console.log(item)
let value = {
status: val
}
let data = {
did: item.pid,
subid: item.device_id,
iszigbee: item.config.iszigbee,
value: JSON.stringify(value)
}
console.log(JSON.stringify(value))
sendcommandnewsub(data).then(res => {
this.$toast('成功')
this.getLoad()
}).catch(() => {})
},

getMPaName (pressure) {
return pressure / 1000000
},

getLevelName (level) {
return level / 100
},
getIsTwo () {
if (this.subDevice.dtype === 504) {
this.isTwo = true
return
}
let item = 0
if (this.subDevice.config.temperature || this.subDevice.config.temperature === 0) {
item += 1
}
if (this.subDevice.config.humidity || this.subDevice.config.humidity === 0) {
item += 1
}
if (this.subDevice.config.voltage || this.subDevice.config.voltage === 0) {
item += 1
}
if (this.subDevice.config.pressure || this.subDevice.config.pressure === 0) {
item += 1
}
if (item > 1) {
this.isTwo = true
} else {
this.isTwo = false
}
},
getIconUrl () {
let key = parseInt(this.subDevice.dtype)
let imgdata = this.imgArr
let img = ''
for (let i = 0; i < imgdata.length; i++) {
if (imgdata[i].dtype === key) {
img = imgdata[i].imgUrl
}
}
if (key === 51) {
if (this.subDevice.config.status === '0') {
img = 'static/newDeviceIcon/big_second_socket1.png'
}
}
if (img === '') {
return imgdata[this.imgArr.length - 1].imgUrl
} else {
return img
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/secondView.vue